import api from 'ApiConfig';

const salaryService = {
  getEmployee: async (employeeType, selectedBranch) => {
    return api.post('/account/get-employee', { employeeType, selectedBranch });
  },
  createEmployeeSalary: async (payload) => {
    return api.post('/account/create-salary', payload);
  },
  getEmployeeSalaryDetails: async (payload) => {
    return api.post('/account/get-employee-salary-details', payload);
  },
  addMonthlySalary: async (payload) => {
    return api.post('/account/add-montly-salary', payload);
  },
  updateEmployeeSalaryDetails: async (payload) => {
    return api.post('/account/update-salary', payload);
  },
};
export default salaryService;
